import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center mt-64" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "SERVER ERROR", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Please refresh the page and try again", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h5", null, _toDisplayString(_ctx.$t(_ctx.$store.getters.configError)), 1),
    _hoisted_3
  ]))
}